import { BlockedPlaceInput } from '../../lib/types/models/blocked-place/blocked-place-input'
import { Center } from '../../lib/types/models/center/center'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const createBlockedPlace = (data: IdInput<BlockedPlaceInput>): Promise<Center> => {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.blockedPlaces.create.url, { id }))
    .post<Center, BlockedPlaceInput>(rest)
}
